import { Injectable } from '@angular/core';
import { AngularFirestore } from "@angular/fire/compat/firestore";
import firebase from "firebase/compat/app";
import { Observable } from "rxjs";
import { CounsellorsMom } from "./counsellors-mom.model";

/**
 * Service for managing Counsellors MOM (Minutes of Meeting) sessions
 */
@Injectable({
  providedIn: 'root'
})
export class CounsellorsMomService {
  private collection = this.firestore.collection<CounsellorsMom>('Counselling/MOM/counsellors-mom-sessions');

  constructor(private firestore: AngularFirestore) {}

  /**
   * Create a new counsellors MOM session
   * @param data The counsellors MOM session data
   */
  create(data: CounsellorsMom): Promise<any> {
    const payload: CounsellorsMom = {
      ...data,
      createdAt: firebase.firestore.FieldValue.serverTimestamp() as any,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp() as any,
    };
    return this.collection.add(payload);
  }

  /**
   * Get a counsellors MOM session by ID
   * @param id The session ID
   */
  getDataById(id: string): Observable<CounsellorsMom | undefined> {
    return this.collection.doc<CounsellorsMom>(id).valueChanges({ idField: 'id' });
  }

  /**
   * Get all counsellors MOM sessions
   */
  getAll(): Observable<CounsellorsMom[]> {
    return this.collection.valueChanges({ idField: 'id' });
  }

  /**
   * Update a counsellors MOM session
   * @param id The session ID
   * @param data The updated data
   */
  update(id: string, data: Partial<CounsellorsMom>): Promise<void> {
    const payload = {
      ...data,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp()
    };
    return this.collection.doc(id).update(payload);
  }

  /**
   * Delete a counsellors MOM session
   * @param id The session ID
   */
  deleteRow(id: string): Promise<void> {
    return this.collection.doc(id).delete();
  }
}

